export default "__VITE_ASSET__BY$rgkNZ__"